export default __webpack_public_path__ + "static/media/Curator's Picks.7e403e8d.svg";